module.exports = __webpack_public_path__ + "img/virtual_card.fa1bbe59.svg";